/**
 * Parses a time string in 'HH:mm:ss' or 'HH:mm' format into a Date object.
 * Uses today's date for consistent comparison.
 *
 * @param {string} timeStr - The time string to parse.
 * @returns {Date} A Date object representing the given time.
 */
function parseTime(timeStr) {
  const [hours, minutes, seconds = '00'] = timeStr.split(':');
  const date = new Date();
  date.setHours(parseInt(hours, 10));
  date.setMinutes(parseInt(minutes, 10));
  date.setSeconds(parseInt(seconds, 10));
  date.setMilliseconds(0);
  return date;
}

/**
 * Sorts an array of time strings in ascending order.
 * Accepts times in 'HH:mm:ss' or 'HH:mm' format.
 *
 * @param {string[]} timeStrings - Array of time strings to sort.
 * @returns {string[]} A new array of sorted time strings.
 */
export function sortTimestamps(timeStrings) {
  return [...timeStrings].sort((a, b) => parseTime(a) - parseTime(b));
}
